import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '500px' },
  maxWidth: '500px',
  bgcolor: '#ffffff',
  borderRadius: '20px',
  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
  p: '30px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  animation: 'slideIn 0.5s ease',
  '@keyframes slideIn': {
    from: { opacity: 0, transform: 'translate(-50%, -50%) translateY(-30px) scale(0.9)' },
    to: { opacity: 1, transform: 'translate(-50%, -50%) translateY(0) scale(1)' },
  },
};

function PreviewExpiredModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="preview-expired-modal-title"
      aria-describedby="preview-expired-modal-description"
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(8px)',
          animation: 'fadeIn 0.4s ease',
          '@keyframes fadeIn': {
            from: { opacity: 0 },
            to: { opacity: 1 },
          },
        },
      }}
    >
      <Box sx={style}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: '16px' }}>
          <Box
            sx={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #ed8936, #f6ad55)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 16px rgba(237, 137, 54, 0.3)',
            }}
          >
            <HourglassEmptyIcon sx={{ fontSize: '36px', color: '#fff' }} />
          </Box>
        </Box>

        <Typography
          id="preview-expired-modal-title"
          component="h2"
          sx={{
            fontSize: '26px',
            fontWeight: 700,
            color: '#2d3748',
            mb: '12px',
            textAlign: 'center',
            letterSpacing: '-0.5px',
          }}
        >
          Preview Session Ended
        </Typography>

        <Typography
          id="preview-expired-modal-description"
          sx={{
            color: '#4a5568',
            lineHeight: 1.7,
            mb: '24px',
            fontSize: '15px',
            textAlign: 'center',
            px: '16px',
          }}
        >
          Your 10-minute preview has ended. Upgrade to Elite tier to get unlimited access to Orderflow charts.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            flexDirection: { xs: 'column', sm: 'row' },
            mt: '8px',
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              flex: 1,
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              color: '#fff',
              py: '13px',
              borderRadius: '12px',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '15px',
              letterSpacing: '0.2px',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.25)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 20px rgba(102, 126, 234, 0.4)',
                background: 'linear-gradient(135deg, #5a6fd8, #6a4190)',
              },
              '&:active': {
                transform: 'translateY(0px)',
              },
            }}
          >
            Okay
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default PreviewExpiredModal;

